import { Dispatch } from "redux";
import { setFormValues } from "../CreateCertificateModalSlice";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { getQualificationFormValidityValues } from "../../../common/utils/getQualificationFormValidityValues";

interface Props {
    selectedEmployee: EmployeeInterface;
    selectedQualification: QualificationInterface;
    dispatch: Dispatch;
}

export const setFormFields = (props: Props): void => {
    const { selectedEmployee, selectedQualification, dispatch } = props;

    dispatch(
        setFormValues({
            ...(selectedEmployee
                ? {
                      employee: {
                          selectedId: selectedEmployee.id.toString(),
                          selectedValue:
                              getUserFullName(selectedEmployee.user) ?? "",
                      },
                  }
                : {}),
            ...(selectedQualification
                ? {
                      qualification: getQualificationFormValidityValues(
                          selectedQualification,
                      ),
                  }
                : {}),
        }),
    );
};
